module.exports = __webpack_public_path__ + "assets/img/tx20g_3.55e6df92.jpg";